import React, { useEffect, useState } from "react";
import { FormikProvider, Form, useFormik } from "formik";
import Menubar from "../Menubar";
import { store } from "../../App";
import MasterService from "../../Services/MasterService";
import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai";
import "jspdf-autotable";
import { Row, Col, Container, Button } from "react-bootstrap";
import KpiService from "../../Services/KpiService";
import useAlert from "../Alert/useAlert";
import AlertModal from "../Alert/AlertModal";
import Select from 'react-select';
import { commonSelectProps, generatedashPdf, exportTodashExcel } from "../utils/commonFunctions";
import { MdOutlinePictureAsPdf } from "react-icons/md";
// import { Alert } from "@mui/material";
import { BarChart, CartesianGrid, XAxis, YAxis, Tooltip as RechartsTooltip, ResponsiveContainer, Cell, Bar, ReferenceLine, LabelList } from "recharts";
import { FaRegHandPointRight } from "react-icons/fa";

export default function ScoreComparisonReport() {
    const { showAlert, alertData, closeAlert } = useAlert();
    const [distEnb, setDistEnb] = useState(false);
    const [mandallist, setMandalList] = useState();
    const [Mandalenb, setMandalenb] = useState(false);
    const [distlist, setDistrictList] = useState([]);
    const [allMandalScores, setAllMandalScores] = useState([]);
    const [selectedMandalScore, setSelectedMandalScore] = useState(null);
    const [Mandalalert, setMandalalert] = useState(false);
    const [searchText, setSearchText] = useState("");
const [selectedDeptId, setSelectedDeptId] = useState("");
const [selectedDist, setSelectedDist] = useState("");
const [selectedmnd, setSelectedmnd] = useState("");
const [dashboardMonthData, setdashboardMonthData] = useState(null);
    // Department comparison states
    const [deptlist, setDeptlist] = useState([]);
    const [allDeptScores, setAllDeptScores] = useState([]);
    const [selectedDeptScore, setSelectedDeptScore] = useState(null);
    const [deptAlert, setDeptAlert] = useState(false);
    const [deptSearchText, setDeptSearchText] = useState("");

    // District comparison states
    const [allDistrictScores, setAllDistrictScores] = useState([]);
    const [selectedDistrictScore, setSelectedDistrictScore] = useState(null);
    const [districtAlert, setDistrictAlert] = useState(false);
    const [districtSearchText, setDistrictSearchText] = useState("");
    const [selectedDistrict] = useState(null);
    const [selectedDistrictId] = useState("0");
    const [selectedMandal] = useState(null);
    const [selectedmandalcode] = useState("0");

    let roleid = localStorage.getItem("catid");
    let role_cat_id = localStorage.getItem("catid");
   
    let selectedsec = localStorage.getItem("secretariat_code");
    let deptid = localStorage.getItem("deptid");
    let ulbdept = localStorage.getItem("deptid");
    let username = localStorage.getItem("username");
    let district = localStorage.getItem("districtid");
    let districtid = localStorage.getItem("districtid");
    let mandal = localStorage.getItem("mandalid");
    let mandalid = localStorage.getItem("mandalid");
    let ulbid = localStorage.getItem("ulbid");
    
    let ulbdeptlist = JSON.parse(localStorage.getItem("ulbdeptlist") || "[]");

    const formik = useFormik({
        initialValues: {
            district_id: "",
            mandal_id: "",
            dept_id: "",
            district_comp_dept_id: "",
            mandal_comp_dept_id: "",
            district_comp_district_id: "",
            year: "2025-26"
        },
    });

    
      const mandaldeptcompareclose=()=>{
        formik.setFieldValue("district_id","");formik.setFieldValue("mandal_id","");setAllMandalScores([]);setSelectedMandalScore(null);
      }
    useEffect(() => {
        // Load districts
        MasterService.getDistricts().then((res17) => {
            if (res17.data) {
                setDistrictList(res17.data);
            }
        });

        // Load departments
        let params = { userId: username };
        MasterService.getDeptartments(params).then((res) => {
            if (res.data) {
                setDeptlist(res.data?.SDESC);
            }
        });

 let param = {
      userId: username, year: "2025-26", type:"sec",
      secId:"0" , deptId: "0", districtId: "0", mandalId: "0", ulbId: "0",
      typeDrill: "Sec",
    };
        store.dispatch({ type: "SHOW_SPINNER" }); 
    KpiService.dashboardKpiData(param).then((res) => {

      if (res.data) {
     

        setdashboardMonthData(res.data?.dataList?.[0]);
      }
    }).catch(() => {
    }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });


        if (["111", "117", "113", "119"].includes(roleid)) {
            formik.setFieldValue("district_id", district);
            MandalDropdown(district);
            setDistEnb(true);
        }

        if (["111", "117"].includes(roleid)) {
            formik.setFieldValue("mandal_id", mandal);
            MandalDropdown(district);
            loadComparisonData(district, mandal);
            setMandalenb(true);
        }

        
        // loadDepartmentComparisonData("0");
    }, []);


    const getSecretariatCode = async (selectedDeptId) => {
        try {
            const deptcodee = deptlist?.find(
                d => d.dept_id === selectedDeptId
            )?.deptcode;

            if (!deptcodee) return "";

            const params = {
                deptId: deptcodee,
                userId: username
            };

            const res = await KpiService.secretariatbaseDeptList(params);
            console.log("res.data.SDESC[0].dept_id", res.data.SDESC[0].dept_id);
            return res?.data?.SDESC?.length > 0
                ? res.data.SDESC[0].dept_id
                : "";
        } catch (error) {
            console.error("Error fetching secretariat code", error);
            return "";
        }
    };

    const renderStatusRing = (score, maxScore = 100, size = 40, strokeWidth = 6) => {
        let parsedScore = parseFloat(score); if (isNaN(parsedScore) || parsedScore < 0) { parsedScore = 0; }
        const normalizedScore = Math.min(parsedScore, maxScore); const radius = (size - strokeWidth) / 2;
        const circumference = 2 * Math.PI * radius; const progress = (normalizedScore / maxScore) * circumference;
        const ringColor = getRingColor(normalizedScore);
        return (
            <svg width={size} height={size} style={{ display: "block" }}>
                <circle stroke="#e6e6e6" fill="transparent" strokeWidth={strokeWidth} r={radius} cx={size / 2} cy={size / 2} />
                <circle stroke={ringColor} fill="transparent" strokeWidth={strokeWidth} strokeDasharray={circumference} strokeDashoffset={circumference - progress} strokeLinecap="round" r={radius} cx={size / 2} cy={size / 2} />
                <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fill="#333" fontWeight="bold" fontSize={size / 4.3}>
                    {normalizedScore} </text> </svg> ); };

    const getColor = (score) => { const num = Number(score); if (!isNaN(num)) {
            if (num >= 90) return "#9ED286"; if (num >= 75 && num < 90) return "#FFCD1E";
            if (num >= 50 && num < 75) return "#3DD9FF"; if (num < 50) return "#FF6E74"; } return "#dcdcdc"; };

    const getGradeColor = (grade) => { switch ((grade || "").toString().trim()) {
            case "A+": return "#9ED286"; case "A": return "#FFCD1E"; case "B": return "#3DD9FF";
            case "C": return "#FF6E74"; default: return "#dcdcdc"; } };

    const getRingColor = (num) => { if (num >= 90 && num <= 100) return "#9ED286"; if (num >= 75 && num < 90) return "#FFCD1E";
        if (num >= 50 && num < 75) return "#3DD9FF"; if (num >= 0 && num < 50) return "#FF6E74"; return "#dcdcdc"; };

    const MandalDropdown = (value) => {
        let params = { "district_id": value }
        MasterService.getMandals(params).then((res) => {
            if (res.data) {
                setMandalList(res.data);
            }
        });
    }

    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

    const handleSort = (key) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }
        setSortConfig({ key, direction });
    };

    const gradeRank = (grade) => {
        switch (grade) {
            case "A+": return 5;
            case "A": return 4;
            case "B+": return 3;
            case "B": return 2;
            case "C": return 1;
            default: return 0;
        }
    };

    // Load department comparison data
    const loadDepartmentComparisonData = async (selectedDeptId) => {
        let secretariatcodee = await getSecretariatCode(selectedDeptId)
setSelectedDeptId(selectedDeptId);

        let params = {
            userId: username,
            year: formik.values.year || "2025-26",
            type: "hod",
            secId: "0",
            "deptId": "0",
            "districtId": selectedDistrict !== null ? selectedDistrictId : "0",
            mandalId: (["117", "111"].includes(role_cat_id)) ?
                (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? "0" : mandalid :
                selectedMandal !== null ? selectedmandalcode : "0",
            ulbId: (["117", "111"].includes(role_cat_id)) ?
                (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? ulbid : "0" : "0",
            typeDrill: (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict === null && selectedMandal === null) ? "hod"
                : (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict && selectedMandal === null) ? "District"
                    : (["116", "115", "114"].includes(role_cat_id)) && (selectedDistrict && selectedMandal) ? "Mandal"
                        : (["119", "113"].includes(role_cat_id)) && (selectedDistrict === null && selectedMandal === null) ? "District"
                            : (["119", "113"].includes(role_cat_id)) && (selectedDistrict && selectedMandal === null) ? "District"
                                : (["119", "113"].includes(role_cat_id)) && (selectedDistrict && selectedMandal) ? "Mandal"
                                    : (["111", "117"].includes(role_cat_id)) && (selectedDistrict === null && selectedMandal === null) ? "Mandal"
                                        : (["111", "117"].includes(role_cat_id)) && (selectedDistrict && selectedMandal === null) ? "District"
                                            : (["111", "117"].includes(role_cat_id)) && (selectedDistrict && selectedMandal) ? "Mandal" : ""
        };




        store.dispatch({ type: "SHOW_SPINNER" });

        KpiService.dashboardKpiScoresGardes(params).then((res) => {
            if (res.data?.SCODE === "02") {
                setAllDeptScores([]);
                setSelectedDeptScore(null);
                setDeptAlert(true);
                return;
            }

            if (res.data && res.data.dataList) {
                setDeptAlert(false);

                // Process department data
                const processedData = res.data.dataList.map(item => ({
                    ...item,
                    isSelected: item.dept_id === selectedDeptId || (selectedDeptId === "0" && item.dept_id === deptid),
                    color_code: item.color_code || getGradeColor(item.grade) || getColor(item.averagescore)
                }));

                // Sort so selected department appears first
                const sortedData = processedData.sort((a, b) => {
                    if (a.isSelected) return -1;
                    if (b.isSelected) return 1;
                    return 0;
                });

                setAllDeptScores(sortedData);

                // Set selected department score for reference line
                const selected = processedData.find(item => item.isSelected);
                setSelectedDeptScore(selected);
            }
        }).catch(() => {
            setAllDeptScores([]);
            setSelectedDeptScore(null);
            setDeptAlert(true);
        }).finally(() => {
            store.dispatch({ type: "HIDE_SPINNER" });
        });
    };

    // Load district comparison data
    const loadDistrictComparisonData = async (selectedDeptId, selectedDistrictId) => {
        if (!selectedDeptId || !selectedDistrictId) return;
        setSelectedDist(selectedDistrictId);
        let secretariatcodee = await getSecretariatCode(selectedDeptId)
        const dept = deptlist.find(d => d.dept_id === selectedDeptId);
        if (!dept) return;

        const paramss = {
            userId: username,
            year: formik.values.year || "2025-26",
            secId: secretariatcodee,
            deptid: selectedDeptId,
            type: "mapHod",
            districtId: "0",
            mandalId: ["117", "111"].includes(role_cat_id) ?
                (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? "0" : mandalid :
                selectedMandal !== null ? selectedmandalcode : "0",
            ulbId: ["117", "111"].includes(role_cat_id) ?
                (ulbdeptlist.includes(ulbdept) || selectedsec === "MAU01") ? ulbid : "0" : "0",
        };

        store.dispatch({ type: "SHOW_SPINNER" });

        KpiService.dashboardKpiScoresGardes(paramss).then((res) => {
            if (res.data?.SCODE === "02") {
                setAllDistrictScores([]);
                setSelectedDistrictScore(null);
                setDistrictAlert(true);
                return;
            }

            if (res.data && res.data.dataList) {
                setDistrictAlert(false);

                
                const processedData = res.data.dataList.map(item => ({
                    ...item,
                    isSelected: item.district_id === selectedDistrictId || (selectedDistrictId === "0" && item.district_id === district),
                    color_code: item.color_code || getGradeColor(item.grade) || getColor(item.averagescore)
                }));

                const sortedData = processedData.sort((a, b) => {
                    if (a.isSelected) return -1;
                    if (b.isSelected) return 1;
                    return 0;
                });

                setAllDistrictScores(sortedData);

                const selected = processedData.find(item => item.isSelected);
                setSelectedDistrictScore(selected);
            }
        }).catch(() => {
            setAllDistrictScores([]);
            setSelectedDistrictScore(null);
            setDistrictAlert(true);
        }).finally(() => {
            store.dispatch({ type: "HIDE_SPINNER" });
        });
    };

    const loadComparisonData = async (dept, districtId, selectedMandalId) => {
        setSelectedmnd(selectedMandalId);
        if (!districtId && !dept) return;
        let secretariatcodee = await getSecretariatCode(dept);
        const params = {
            userId: username,
            year: "2025-26",
            secId: secretariatcodee,
            deptId: dept,
            districtId: "0",
            mandalId: "0", 
            ulbId: "0",
        };

        store.dispatch({ type: "SHOW_SPINNER" });

        KpiService.dashboardMandalWiseIndicatorDataTab(params).then((res) => {
            if (res.data?.SCODE === "02") {
                setAllMandalScores([]);
                setSelectedMandalScore(null);
                setMandalalert(true);
                return;
            }

            if (res.data?.dataList) {
                setMandalalert(false);

                const processedData = res.data.dataList.map(item => ({
                    ...item,
                    isSelected: item.mandal_id === selectedMandalId,
                    color_code: item.color_code || getGradeColor(item.grade) || getColor(item.averagescore)
                }));

                const sortedData = processedData.sort((a, b) => {
                    if (a.isSelected) return -1;
                    if (b.isSelected) return 1;
                    return 0;
                });

                setAllMandalScores(sortedData);

                const selected = processedData.find(item => item.mandal_id === selectedMandalId);
                setSelectedMandalScore(selected);
            }
        }).finally(() => {
            store.dispatch({ type: "HIDE_SPINNER" });
        });
    };

    // Filter and sort department data
    // const filteredAndSortedDeptData = React.useMemo(() => {
    //     let data = [...allDeptScores];

    //     // Apply search filter
    //     if (deptSearchText && deptSearchText.trim().length > 0) {
    //         data = data.filter((item) =>
    //             Object.values(item || {}).some((value) =>
    //                 value !== null &&
    //                 value.toString().toLowerCase().includes(deptSearchText.toLowerCase())
    //             )
    //         );
    //     }

    //     // Apply sorting
    //     if (sortConfig.key) {
    //         data.sort((a, b) => {
    //             const valA =
    //                 sortConfig.key === "achievedscore"
    //                     ? a.averagescore
    //                     : sortConfig.key === "achievedgrade"
    //                         ? gradeRank(a.grade)
    //                         : sortConfig.key === "noofindicators"
    //                             ? Number(a.noofindicators)
    //                             : sortConfig.key === "dept_name"
    //                                 ? a.dept_name
    //                                 : a.dept_name;

    //             const valB =
    //                 sortConfig.key === "achievedscore"
    //                     ? b.averagescore
    //                     : sortConfig.key === "achievedgrade"
    //                         ? gradeRank(b.grade)
    //                         : sortConfig.key === "noofindicators"
    //                             ? Number(b.noofindicators)
    //                             : sortConfig.key === "dept_name"
    //                                 ? b.dept_name
    //                                 : b.dept_name;

    //             if (valA === null || valA === undefined) return 1;
    //             if (valB === null || valB === undefined) return -1;

    //             if (typeof valA === 'string' && typeof valB === 'string') {
    //                 return sortConfig.direction === "asc"
    //                     ? valA.localeCompare(valB)
    //                     : valB.localeCompare(valA);
    //             }

    //             return sortConfig.direction === "asc" ? valA - valB : valB - valA;
    //         });
    //     }

    //     return data;
    // }, [allDeptScores, deptSearchText, sortConfig]);


    const filteredAndSortedDeptData = React.useMemo(() => {
    if (!allDeptScores || allDeptScores.length === 0) return [];

    // 1️⃣ Identify selected department
    const selectedDept = allDeptScores.find(
        item => item.dept_id === selectedDeptId || 
               (selectedDeptId === "0" && item.dept_id === deptid)
    );

    // 2️⃣ Remaining departments
    let remainingData = allDeptScores.filter(
        item => item !== selectedDept
    );

    // 3️⃣ Apply search ONLY on remaining data
    if (deptSearchText && deptSearchText.trim().length > 0) {
        remainingData = remainingData.filter(item =>
            Object.values(item || {}).some(value =>
                value !== null &&
                value.toString().toLowerCase().includes(deptSearchText.toLowerCase())
            )
        );
    }

    // 4️⃣ Apply sorting ONLY on remaining data
    if (sortConfig.key) {
        remainingData.sort((a, b) => {
            const getValue = (item) => {
                switch (sortConfig.key) {
                    case "achievedscore":
                        return item.averagescore;
                    case "achievedgrade":
                        return gradeRank(item.grade);
                    case "noofindicators":
                        return Number(item.noofindicators);
                    case "dept_name":
                        return item.dept_name;
                    default:
                        return item.dept_name;
                }
            };

            const valA = getValue(a);
            const valB = getValue(b);

            if (valA == null) return 1;
            if (valB == null) return -1;

            if (typeof valA === "string") {
                return sortConfig.direction === "asc"
                    ? valA.localeCompare(valB)
                    : valB.localeCompare(valA);
            }

            return sortConfig.direction === "asc"
                ? valA - valB
                : valB - valA;
        });
    }

    // 5️⃣ Merge selected department + filtered remaining
    return selectedDept
        ? [selectedDept, ...remainingData]
        : remainingData;

}, [allDeptScores, deptSearchText, sortConfig, selectedDeptId, deptid]);

    // Filter and sort district data
    // const filteredAndSortedDistrictData = React.useMemo(() => {
    //     let data = [...allDistrictScores];

    //     // Apply search filter
    //     if (districtSearchText && districtSearchText.trim().length > 0) {
    //         data = data.filter((item) =>
    //             Object.values(item || {}).some((value) =>
    //                 value !== null &&
    //                 value.toString().toLowerCase().includes(districtSearchText.toLowerCase())
    //             )
    //         );
    //     }

    //     // Apply sorting
    //     if (sortConfig.key) {
    //         data.sort((a, b) => {
    //             const valA =
    //                 sortConfig.key === "achievedscore"
    //                     ? a.averagescore
    //                     : sortConfig.key === "achievedgrade"
    //                         ? gradeRank(a.grade)
    //                         : sortConfig.key === "noofindicators"
    //                             ? Number(a.noofindicators)
    //                             : sortConfig.key === "district_name"
    //                                 ? a.district_name
    //                                 : a.district_name;

    //             const valB =
    //                 sortConfig.key === "achievedscore"
    //                     ? b.averagescore
    //                     : sortConfig.key === "achievedgrade"
    //                         ? gradeRank(b.grade)
    //                         : sortConfig.key === "noofindicators"
    //                             ? Number(b.noofindicators)
    //                             : sortConfig.key === "district_name"
    //                                 ? b.district_name
    //                                 : b.district_name;

    //             if (valA === null || valA === undefined) return 1;
    //             if (valB === null || valB === undefined) return -1;

    //             if (typeof valA === 'string' && typeof valB === 'string') {
    //                 return sortConfig.direction === "asc"
    //                     ? valA.localeCompare(valB)
    //                     : valB.localeCompare(valA);
    //             }

    //             return sortConfig.direction === "asc" ? valA - valB : valB - valA;
    //         });
    //     }

    //     return data;
    // }, [allDistrictScores, districtSearchText, sortConfig]);

     const filteredAndSortedDistrictData = React.useMemo(() => {
      if (!allDistrictScores || allDistrictScores.length === 0) return [];

    // 1️⃣ Identify selected department
    const selecteddist = allDistrictScores.find(
        item => item.district_id === selectedDist || 
               (selectedDistrictId === "0" && item.district_id === districtid)
    );

     let remainingData = allDistrictScores.filter(
        item => item !== selecteddist
    );

    // 3️⃣ Apply search ONLY on remaining data
    if (districtSearchText && districtSearchText.trim().length > 0) {
        remainingData = remainingData.filter(item =>
            Object.values(item || {}).some(value =>
                value !== null &&
                value.toString().toLowerCase().includes(districtSearchText.toLowerCase())
            )
        );
    }
        

        // Apply sorting
        if (sortConfig.key) {
            remainingData.sort((a, b) => {
                const valA =
                    sortConfig.key === "achievedscore"
                        ? a.averagescore
                        : sortConfig.key === "achievedgrade"
                            ? gradeRank(a.grade)
                            : sortConfig.key === "noofindicators"
                                ? Number(a.noofindicators)
                                : sortConfig.key === "district_name"
                                    ? a.district_name
                                    : a.noofindicators;

                const valB =
                    sortConfig.key === "achievedscore"
                        ? b.averagescore
                        : sortConfig.key === "achievedgrade"
                            ? gradeRank(b.grade)
                            : sortConfig.key === "noofindicators"
                                ? Number(b.noofindicators)
                                : sortConfig.key === "district_name"
                                    ? b.district_name
                                    : b.noofindicators;

                if (valA === null || valA === undefined) return 1;
                if (valB === null || valB === undefined) return -1;

                if (typeof valA === 'string' && typeof valB === 'string') {
                    return sortConfig.direction === "asc"
                        ? valA.localeCompare(valB)
                        : valB.localeCompare(valA);
                }

                return sortConfig.direction === "asc" ? valA - valB : valB - valA;
            });
        }

        return selecteddist
        ? [selecteddist, ...remainingData]
        : remainingData;
    }, [allDistrictScores, districtSearchText, sortConfig,selectedDist, districtid]);
    // Filter and sort mandal data
    const filteredAndSortedData = React.useMemo(() => {
        // let data = [...allMandalScores];

        // // Apply search filter
        // if (searchText && searchText.trim().length > 0) {
        //     data = data.filter((item) =>
        //         Object.values(item || {}).some((value) =>
        //             value !== null &&
        //             value.toString().toLowerCase().includes(searchText.toLowerCase())
        //         )
        //     );
        // }
if (!allMandalScores || allMandalScores.length === 0) return [];

    const selectedmandal = allMandalScores.find(
        item => item.mandal_id === selectedmnd || 
               (selectedmandalcode === "0" && item.mandal_id === districtid)
    );

     let remainingData = allMandalScores.filter(
        item => item !== selectedmandal
    );

    if (searchText && searchText.trim().length > 0) {
        remainingData = remainingData.filter(item =>
            Object.values(item || {}).some(value =>
                value !== null &&
                value.toString().toLowerCase().includes(searchText.toLowerCase())
            )
        );
    }
        

        if (sortConfig.key) {
            remainingData.sort((a, b) => {
                const valA =
                    sortConfig.key === "achievedscore"
                        ? a.averagescore
                        : sortConfig.key === "achievedgrade"
                            ? gradeRank(a.grade)
                            : sortConfig.key === "noofindicators"
                                ? Number(a.noofindicators)
                                : sortConfig.key === "mandal_name"
                                    ? a.mandal_name
                                    : a.district_name;

                const valB =
                    sortConfig.key === "achievedscore"
                        ? b.averagescore
                        : sortConfig.key === "achievedgrade"
                            ? gradeRank(b.grade)
                            : sortConfig.key === "noofindicators"
                                ? Number(b.noofindicators)
                                : sortConfig.key === "mandal_name"
                                    ? b.mandal_name
                                    : b.district_name;

                if (valA === null || valA === undefined) return 1;
                if (valB === null || valB === undefined) return -1;

                if (typeof valA === 'string' && typeof valB === 'string') {
                    return sortConfig.direction === "asc"
                        ? valA.localeCompare(valB)
                        : valB.localeCompare(valA);
                }

                return sortConfig.direction === "asc" ? valA - valB : valB - valA;
            });
        }

        return selectedmandal
        ? [selectedmandal, ...remainingData]
        : remainingData;
    }, [allMandalScores, searchText, sortConfig, selectedmnd, mandalid]);

    const BAR_WIDTH = 30;          
const BAR_GAP = 15;           
const MIN_CHART_WIDTH = 800;

const chartWidth = Math.max(
  filteredAndSortedData?.length * (BAR_WIDTH + BAR_GAP),
  MIN_CHART_WIDTH
);

    return (
        <>
            <Menubar />
            {/* Enhanced Header with Gradient Background */}
           

            <Container fluid style={{
                width: "96%",
                backgroundColor: "#f8f9fa",
                minHeight: "100vh",
                padding: "20px"
            }} className="outer-page-content-container">
                <FormikProvider value={formik}>
                    <Form onSubmit={formik.handleSubmit}>
                        {/* <div className="text-end">
<h3
                            style={{ display: "flex", alignItems: "center", gap: "10px", fontWeight: "bold", fontSize: "18px", }}
                        >
                         
                            <FaRegHandPointRight style={{ color: "red", animation: "blink 1s step-start infinite", }} />

                          
                            <h6>
                                <span style={{ color: "green" }}> Scores – Generated upto </span> {dashboardMonthData?.score_for_month
                                    ? ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December",
                                    ][Number(dashboardMonthData.score_for_month) - 1] : ""}{" "} Month </h6>

                           
                            <style>
                                {`
      @keyframes blink {
        50% { opacity: 0; }
      }
    `}
                            </style>
                        </h3>
                        </div> */}
                        <div className="text-end">
  <div
    style={{
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "10px",
      fontWeight: "bold",
      fontSize: "18px",
      textAlign: "right",
    }}
  >
    {/* Blinking Icon */}
    <FaRegHandPointRight
      style={{
        color: "red",
        animation: "blink 1s step-start infinite",
      }}
    />

    {/* Text */}
    <span>
      <span style={{ color: "green" }}>Scores – Generated upto </span>
      {dashboardMonthData?.score_for_month
        ? [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December",
          ][Number(dashboardMonthData.score_for_month) - 1]
        : ""}
      {" "}Month
    </span>
  </div>

  {/* Keyframes */}
  <style>
    {`
      @keyframes blink {
        50% { opacity: 0; }
      }
    `}
  </style>
</div>

                        {/* Department Wise Comparison Section */}
                        <div className="comparison-section-header" style={{
                            background: "linear-gradient(90deg, #4e835c 0%, #6ba16f 100%)",
                            padding: "7px 20px",
                            borderRadius: "12px 12px 0 0",
                            marginTop: "10px",
                            boxShadow: "0 4px 15px rgba(0,0,0,0.1)"
                        }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                               
                                <div>
                                    <h2 style={{
                                        color: "white",
                                        margin: "0",
                                        fontSize: "20px",
                                        fontWeight: "600"
                                    }}>Department v/s  Department Scores Comparison</h2>
                                </div> </div> </div>

                        <div style={{ backgroundColor: "white", borderRadius: "0 0 12px 12px",
                            boxShadow: "0 4px 15px rgba(0,0,0,0.1)", overflow: "hidden" }}>
                            <Row className="g-0">
                                {/* Department Graph Section */}
                                <Col md={7} className="border-end"> <div style={{ padding: "25px", height: "550px",
                                        position: "relative", backgroundColor: "#fafbfc" }}>
                                        {/* Enhanced Department Dropdown */}
                                        <div style={{ position: "absolute", top: "20px", left: "20px", zIndex: 10,
                                            minWidth: "250px", backgroundColor: "white", padding: "15px", borderRadius: "10px",
                                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                            border: "1px solid #e1e5e9"
                                        }}>
                                            <label className="mb-2 fw-bold" style={{
                                                fontSize: "13px",
                                                color: "#495057",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px"
                                            }}>
                                                Department
                                            </label>
                                            <Select
                                                {...commonSelectProps({
                                                    name: "dept_id",
                                                    options: deptlist,
                                                    value: formik.values.dept_id,
                                                    optionValueKey: "dept_id",
                                                    optionLabelKey: "dept_name",
                                                    formik,
                                                    isDisabled: false,
                                                    extraOnChange: (option) => {
                                                        loadDepartmentComparisonData(option ? option.dept_id : "0");
                                                    }
                                                })}
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        
                                                        minHeight: "38px",
                                                        fontSize: "13px",
                                                        borderRadius: "8px",
                                                        border: "2px solid #e9ecef",
                                                        boxShadow: "none",
                                                        "&:hover": {
                                                            border: "2px solid #4e835c"
                                                        }
                                                    }),
                                                    option: (base, state) => ({
                                                        ...base,
                                                        backgroundColor: state.isSelected ? "#4e835c" : state.isFocused ? "#f8f9fa" : "white",
                                                        color: state.isSelected ? "white" : "#495057"
                                                    })
                                                }}
                                            />
                                        </div>

                                        {/* Enhanced Department Graph */}
                                        <div style={{
                                            marginTop: "100px",
                                            height: "calc(100% - 100px)",
                                            overflow: "auto",
                                            backgroundColor: "white",
                                            borderRadius: "10px",
                                            padding: "15px",
                                            boxShadow: "inset 0 2px 4px rgba(0,0,0,0.06)"
                                        }}>
                                            {/* {allDeptScores.length > 0 ? (
                                                <ResponsiveContainer width="100%" height="100%" id="my-chart1">
                                                    <BarChart
                                                        data={filteredAndSortedDeptData}
                                                        margin={{ top: 20, right: 30, left: 20, bottom: 80 }}
                                                    >
                                                       
                                                        <XAxis
                                                            dataKey="dept_name"
                                                            angle={315}
                                                            textAnchor="end"
                                                            interval={0}
                                                            height={80}
                                                            tick={{ fontSize: 10 }}
                                                        />
                                                        <YAxis
                                                            domain={[0, 100]}
                                                            tickFormatter={(v) => `${v}%`}
                                                            tick={{ fontSize: 10 }}
                                                        />
                                                        <RechartsTooltip formatter={(v) => [`${v}%`, "Score"]} />

                                                       
                                                        {selectedDeptScore && (
                                                            <ReferenceLine
                                                                y={selectedDeptScore.averagescore}
                                                                stroke={selectedDeptScore.color_code || "#000"}
                                                                strokeWidth={2}
                                                                strokeDasharray="5 5"
                                                                label={{
                                                                    value: `${selectedDeptScore.dept_name}: ${selectedDeptScore.averagescore}%`,
                                                                    position: "topRight",
                                                                    fontSize: 10,
                                                                    fontWeight: 600,
                                                                    fill: selectedDeptScore.color_code || "#000",
                                                                }}
                                                            />
                                                        )}

                                                        <Bar dataKey="averagescore" barSize={30}>
                                                            {filteredAndSortedDeptData.map((item, index) => (
                                                                <Cell
                                                                    key={index}
                                                                    fill={item.color_code}
                                                                    opacity={item.isSelected ? 1 : 0.6}
                                                                    stroke={item.isSelected ? "#000" : "none"}
                                                                    strokeWidth={item.isSelected ? 2 : 0}
                                                                />
                                                            ))}
                                                        </Bar>
                                                    </BarChart>
                                                </ResponsiveContainer>
                                            ) : (
                                               <div style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                height: "100%",
                                                color: "#666"
                                            }}>
                                                {deptAlert ? "No department data available" : "Loading department comparison..."}
                                            </div>
                                            )} */}
                                            
{allDeptScores.length > 0 ? (
  <div style={{ overflowX: "auto", width: "100%" }}>
    <div style={{ minWidth: `${filteredAndSortedDeptData.length * 30}px`, height: "350px" }}>
      <ResponsiveContainer width="100%" height="100%" id="my-chart1">
        <BarChart
          data={filteredAndSortedDeptData}
          margin={{ top: 20, right: 30, left: 20, bottom: 80 }} 
        //   barCategoryGap={4} 
        >
          <XAxis
            dataKey="deptcode"
            angle={315}
            textAnchor="end"
            interval={0}
            height={80}
            tick={{ fontSize: 10 }}
          />
          <YAxis
            domain={[0, 100]}
            tickFormatter={(v) => `${v}%`}
            tick={{ fontSize: 10 }}
          />
          <RechartsTooltip formatter={(v) => [`${v}%`, "Score"]} />

          {/* Reference line only for selected department */}
          {selectedDeptScore && (
            <ReferenceLine
              y={selectedDeptScore.averagescore}
              stroke={selectedDeptScore.color_code || "#000"}
              strokeWidth={2}
              strokeDasharray="5 5"
              label={{
                value: `${selectedDeptScore.dept_name}: ${selectedDeptScore.averagescore}%`,
                position: "topRight",
                fontSize: 10,
                fontWeight: 100,
                // fill: selectedDeptScore.color_code || "#000",
                                                                    fill: "#96ebcaff",

              }}
            />
          )}

          <Bar dataKey="averagescore" barSize={30} minPointSize={5}>
            {filteredAndSortedDeptData.map((item, index) => {
              const isSelectedDept = selectedDeptScore && item.dept_id === selectedDeptScore.dept_id;
              return (
                <Cell
                  key={index}
                  fill={"#96ebcaff"}
                  opacity={isSelectedDept ? 1 : 0.6}  
                  stroke={isSelectedDept ? "#000" : "none"}
                  strokeWidth={isSelectedDept ? 1 : 0}
                />
              );
            })}
            {/* Score above each bar */}
            <LabelList
              dataKey="averagescore"
              position="top"
              fill="#000"
              formatter={(value) => `${value}%`}
              fontSize={10}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  </div>
) : (
  <div style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    color: "#666"
  }}>
    {deptAlert ? "No department data available" : "Select department to view comparison"}
  </div>
)}






    </div>
 </div>
                                        {/* </div>
                                    </div> */}
                                </Col>

                              
                                <Col md={5}>
                                    <div style={{
                                        padding: "25px",
                                        height: "550px",
                                        backgroundColor: "white"
                                    }}>

                                        {/* Enhanced Search and Export Controls */}
                                        <div style={{
                                            backgroundColor: "#f8f9fa",
                                            padding: "15px",
                                            borderRadius: "10px",
                                            marginBottom: "20px",
                                            border: "1px solid #e9ecef"
                                        }}>
                                            <Row className="align-items-center">
                                                <Col md={7}>
                                                    <div className="input-group">
                                                        <div className="input-group-prepend"> </div>
                                                        <input type="text" className="form-control"
                                                            placeholder="🔍 Search departments..." value={deptSearchText}
                                                            onChange={(e) => setDeptSearchText(e.target.value)}
                                                            style={{ fontSize: "13px", border: "2px solid #e9ecef", }}
                                                        /> </div> </Col>
                                                <Col md={5} className="text-end">
                                                    <Button className="btn btn-danger btn-sm me-2"
                                                        onClick={() => generatedashPdf("dept-comparison-table", "Department Comparison", 5,"my-chart1", "Department Wise Scores Comparison")}
                                                        style={{ fontSize: "12px", borderRadius: "6px", padding: "6px 12px" }} >
                                                        <MdOutlinePictureAsPdf /> PDF </Button>
                                                    <Button variant="success" size="sm"
                                                        onClick={() => exportTodashExcel("dept-comparison-table", "Department Comparison")}
                                                        style={{ fontSize: "12px", borderRadius: "6px", padding: "6px 12px" }} >
                                                        <AiFillFileExcel /> Excel </Button> </Col> </Row> </div>
                                        {/* Enhanced Department Table */}
                                        <div style={{ height: "calc(100% - 100px)", overflowY: "auto",
                                            border: "2px solid #e9ecef", borderRadius: "10px",
                                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
                                            <table className="table table-bordered table-sm mb-0"
                                                id="dept-comparison-table" style={{ fontSize: "11px" }} >
                                                <thead className="sticky-top" style={{ backgroundColor: "#4e835c", color: "white" }}>
                                                    <tr> <th style={{ width: "8%", backgroundColor: "#4e835c", color: "white" }}>S.No</th>
                                                        <th style={{ width: "40%", backgroundColor: "#4e835c", color: "white" }}> Department Name
                                                            <button style={{ border: "none", background: "transparent", color: "white", marginLeft: "5px" }}
                                                                onClick={() => handleSort("dept_name")} > {sortConfig.key === "dept_name"
                                                                    ? sortConfig.direction === "asc" ? "▲" : "▼"
                                                                    : "↕"} </button> </th>
                                                        <th style={{ width: "20%", backgroundColor: "#4e835c", color: "white" }}> Indicators
                                                            <button
                                                                style={{ border: "none", background: "transparent", color: "white", marginLeft: "5px" }}
                                                                onClick={() => handleSort("noofindicators")} >
                                                                {sortConfig.key === "noofindicators"
                                                                    ? sortConfig.direction === "asc" ? "▲" : "▼"
                                                                    : "↕"} </button> </th>
                                                        <th style={{ width: "17%", backgroundColor: "#4e835c", color: "white" }}> Score
                                                            <button style={{ border: "none", background: "transparent", color: "white", marginLeft: "5px" }}
                                                                onClick={() => handleSort("achievedscore")} >
                                                                {sortConfig.key === "achievedscore"
                                                                    ? sortConfig.direction === "asc" ? "▲" : "▼"
                                                                    : "↕"} </button> </th>
                                                        <th style={{ width: "20%", backgroundColor: "#4e835c", color: "white" }}> Grade
                                                            <button style={{ border: "none", background: "transparent", color: "white", marginLeft: "5px" }}
                                                                onClick={() => handleSort("achievedgrade")} >
                                                                {sortConfig.key === "achievedgrade"
                                                                    ? sortConfig.direction === "asc" ? "▲" : "▼"
                                                                    : "↕"} </button> </th> </tr> </thead>
                                                <tbody>
                                                    {filteredAndSortedDeptData.length === 0 ? (
                                                        <tr>
                                                            <td className="text-center" colSpan="4">
                                                                <b style={{ color: "red" }}>
                                                                    {deptAlert ? "Details Not Found" : "No data to display"}
                                                                </b>
                                                            </td>
                                                        </tr>
                                                    ) : (
                                                        filteredAndSortedDeptData.map((detail, i) => (
                                                            <tr
                                                                key={i}
                                                                style={{
                                                                    backgroundColor: detail.isSelected ? "#fff3cd" : "transparent",
                                                                    fontWeight: detail.isSelected ? "bold" : "normal"
                                                                }}
                                                            >
                                                                <td className="text-center">{i + 1}</td>
                                                                <td>{detail?.deptcode}<br/>{detail?.dept_name}</td>
                                                                <td style={{ textAlign: "right" }}>{detail?.noofindicators}</td>
                                                                <td className="text-center">
                                                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                                                        {renderStatusRing(detail.averagescore, 100, 30, 4)}
                                                                    </div> </td>
                                                                <td className="text-center">{detail.grade}</td> </tr> )) )} </tbody> </table>
                                        </div> </div> </Col> </Row> </div>
                        <div className="comparison-section-header" style={{
                            background: "linear-gradient(90deg, #4e835c 0%, #6ba16f 100%)",
                            // background: "linear-gradient(90deg, #667eea 0%, #764ba2 100%)",
                            padding: "7px 20px", borderRadius: "12px 12px 0 0", marginTop: "40px",
                            boxShadow: "0 4px 15px rgba(0,0,0,0.1)"
                        }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                                <div> <h2 style={{ color: "white", margin: "0", fontSize: "20px", fontWeight: "600"
                                    }}>Department Wise District Scores Comparison</h2> </div> </div> </div>
                      <div style={{ backgroundColor: "white", borderRadius: "0 0 12px 12px",
                            boxShadow: "0 4px 15px rgba(0,0,0,0.1)", overflow: "hidden" }}>
                            <Row className="g-0">
                                {/* District Graph Section */}
                                <Col md={7} className="border-end">
                                    <div style={{ padding: "25px", height: "550px",
                                        position: "relative", backgroundColor: "#fafbfc" }}>
                                        {/* Enhanced Department and District Dropdowns */}
                                        <div style={{
                                            position: "absolute",
                                            top: "20px",
                                            left: "20px",
                                            zIndex: 10,
                                            display: "flex",
                                            gap: "15px",
                                            backgroundColor: "white",
                                            padding: "15px",
                                            borderRadius: "10px",
                                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                            border: "1px solid #e1e5e9"
                                        }}>
                                            <div style={{ minWidth: "180px",maxWidth: "350px" }}>
                                                <label className="mb-1 fw-bold" style={{ fontSize: "12px" }}>Department</label>
                                                <Select
                                                    {...commonSelectProps({
                                                        name: "district_comp_dept_id",
                                                        options: deptlist,
                                                        value: formik.values.district_comp_dept_id,
                                                        optionValueKey: "dept_id",
                                                        optionLabelKey: "dept_name",
                                                        formik,
                                                        isDisabled: false,
                                                        extraOnChange: (option) => {
                                                        formik.setFieldValue("district_comp_district_id", "");
                                                        setAllDistrictScores([]);
                                                        } })}
                                                     styles={{
                                                    control: (base) => ({ ...base,
                                                        minHeight: "38px", fontSize: "13px", borderRadius: "8px",
                                                        border: "2px solid #e9ecef", boxShadow: "none",
                                                        "&:hover": { border: "2px solid #4e835c" } }),
                                                    option: (base, state) => ({ ...base,
                                                        backgroundColor: state.isSelected ? "#4e835c" : state.isFocused ? "#f8f9fa" : "white",
                                                        color: state.isSelected ? "white" : "#495057"
                                                    }) }} /> </div>
                                            <div style={{ minWidth: "180px",maxWidth: "300px" }}>
                                                <label className="mb-1 fw-bold" style={{ fontSize: "12px" }}>District</label>
                                                <Select {...commonSelectProps({
                                                        name: "district_comp_district_id", options: distlist,
                                                        value: formik.values.district_comp_district_id,
                                                        optionValueKey: "id", optionLabelKey: "value",
                                                        formik, isDisabled: false,
                                                        extraOnChange: (option) => {
                                                            if (formik.values.district_comp_dept_id) {
                                                                loadDistrictComparisonData(
                                                                    formik.values.district_comp_dept_id,
                                                                    option ? option.id : "0"
                                                                ); } } })}
                                                     styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        minHeight: "38px", fontSize: "13px",
                                                        borderRadius: "8px", border: "2px solid #e9ecef", boxShadow: "none",
                                                        "&:hover": {
                                                            border: "2px solid #4e835c"
                                                        } }),
                                                    option: (base, state) => ({
                                                        ...base,
                                                        backgroundColor: state.isSelected ? "#4e835c" : state.isFocused ? "#f8f9fa" : "white",
                                                        color: state.isSelected ? "white" : "#495057"
                                                    }) }} /> </div> </div>

                                        {/* District Graph */}
                                        <div style={{
                                            marginTop: "100px",
                                            height: "calc(100% - 100px)",
                                            overflow: "auto",
                                            backgroundColor: "white",
                                            borderRadius: "10px",
                                            padding: "15px",
                                            boxShadow: "inset 0 2px 4px rgba(0,0,0,0.06)"
                                        }}>
                                            {allDistrictScores.length > 0 ? (
                                                <ResponsiveContainer width="100%" height="100%" id="my-chart2">
                                                    <BarChart
                                                        data={filteredAndSortedDistrictData}
                                                        margin={{ top: 20, right: 30, left: 20, bottom: 80 }}
                                                    >
                                                        {/* <CartesianGrid strokeDasharray="3 3" /> */}
                                                        <XAxis
                                                            dataKey="district_name"
                                                            angle={315}
                                                            textAnchor="end"
                                                            interval={0}
                                                            height={80}
                                                            tick={{ fontSize: 10 }}
                                                        />
                                                        <YAxis
                                                            domain={[0, 100]}
                                                            tickFormatter={(v) => `${v}%`}
                                                            tick={{ fontSize: 10 }}
                                                        />
                                                        <RechartsTooltip formatter={(v) => [`${v}%`, "Score"]} />

                                                        {/* Reference line for selected district */}
                                                        {selectedDistrictScore && (
                                                            <ReferenceLine
                                                                y={selectedDistrictScore.averagescore}
                                                                stroke={selectedDistrictScore.color_code || "#000"}
                                                                strokeWidth={2}
                                                                strokeDasharray="5 5"
                                                                label={{
                                                                    value: `${selectedDistrictScore.district_name}: ${selectedDistrictScore.averagescore}%`,
                                                                    position: "topRight",
                                                                    fontSize: 10,
                                                                    fontWeight: 50,
                                                                    // fill: selectedDistrictScore.color_code || "#000",
                                                                    fill: "#96ebcaff",

                                                                }}
                                                            />
                                                        )}

                                                        <Bar dataKey="averagescore" barSize={30}>
                                                            {filteredAndSortedDistrictData.map((item, index) => (
                                                                <Cell
                                                                    key={index}
                                                                    // fill={item.color_code}
                                                                    fill={"#96ebcaff"}
                                                                    opacity={item.isSelected ? 1 : 0.6}
                                                                    stroke={item.isSelected ? "#000" : "none"}
                                                                    strokeWidth={item.isSelected ? 1 : 0}
                                                                />
                                                            ))}
                                                            <LabelList
              dataKey="averagescore"
              position="top"
              fill="#000"
              formatter={(value) => `${value}%`}
              fontSize={9}
            />
                                                        </Bar>
                                                    </BarChart>
                                                </ResponsiveContainer>
                                            ) : (
                                                <div style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                height: "100%",
                                                color: "#666"
                                            }}>
                                                {districtAlert ? "No district data available" : "Select department and district to view district comparison"}
                                            </div> )} </div> </div> </Col>

                                {/* District Table Section */}
                                <Col md={5}> <div style={{ padding: "25px", height: "550px", backgroundColor: "white" }}>

                                        {/* Search and Export Controls */}
                                         <div style={{ backgroundColor: "#f8f9fa", padding: "15px", borderRadius: "10px",
                                            marginBottom: "20px", border: "1px solid #e9ecef" }}>
                                            <Row className="align-items-center"> <Col md={7}> <div className="input-group"> <div className="input-group-prepend">
                                                        </div>
                                                        <input type="text" className="form-control"
                                                            placeholder="🔍 Search districts..." value={districtSearchText} onChange={(e) => setDistrictSearchText(e.target.value)}
                                                            style={{ fontSize: "13px", border: "2px solid #e9ecef", }} /> </div> </Col>
                                                <Col md={5} className="text-end"> <Button className="btn btn-danger btn-sm me-2"
                                                        onClick={() => generatedashPdf("district-comparison-table", "District Comparison", 5,"my-chart2", "District Wise Scores Comparison")}
                                                        style={{ fontSize: "12px", borderRadius: "6px", padding: "6px 12px" }} >
                                                        <MdOutlinePictureAsPdf /> PDF </Button>
                                                    <Button variant="success" size="sm"
                                                        onClick={() => exportTodashExcel("district-comparison-table", "District Comparison")}
                                                        style={{ fontSize: "12px", borderRadius: "6px", padding: "6px 12px" }} >
                                                        <AiFillFileExcel /> Excel </Button> </Col> </Row> </div>

                                        {/* District Table */}
                                        <div style={{
                                            height: "calc(100% - 100px)",
                                            overflowY: "auto",
                                            border: "2px solid #e9ecef",
                                            borderRadius: "10px",
                                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
                                        }}>
                                            <table
                                                className="table table-bordered table-sm mb-0"
                                                id="district-comparison-table"
                                                style={{ fontSize: "11px" }}
                                            >
                                                <thead className="sticky-top" style={{ backgroundColor: "#4e835c", color: "white" }}>
                                                    <tr>
                                                        <th style={{ width: "8%", backgroundColor: "#4e835c", color: "white" }}>S.No</th>
                                                        <th style={{ width: "40%", backgroundColor: "#4e835c", color: "white" }}>
                                                            District Name <button
                                                                style={{ border: "none", background: "transparent", color: "white", marginLeft: "5px" }}
                                                                onClick={() => handleSort("district_name")} >
                                                                {sortConfig.key === "district_name"
                                                                    ? sortConfig.direction === "asc" ? "▲" : "▼" : "↕"} </button> </th>
                                                        <th style={{ width: "20%", backgroundColor: "#4e835c", color: "white" }}> Indicators
                                                            <button
                                                                style={{ border: "none", background: "transparent", color: "white", marginLeft: "5px" }}
                                                                onClick={() => handleSort("noofindicators")} >
                                                                {sortConfig.key === "noofindicators"
                                                                    ? sortConfig.direction === "asc" ? "▲" : "▼"
                                                                    : "↕"} </button> </th>
                                                        <th style={{ width: "17%", backgroundColor: "#4e835c", color: "white" }}> Score
                                                            <button style={{ border: "none", background: "transparent", color: "white", marginLeft: "5px" }}
                                                                onClick={() => handleSort("achievedscore")} >
                                                                {sortConfig.key === "achievedscore"
                                                                    ? sortConfig.direction === "asc" ? "▲" : "▼" : "↕"} </button> </th>
                                                        <th style={{ width: "20%", backgroundColor: "#4e835c", color: "white" }}> Grade
                                                            <button
                                                                style={{ border: "none", background: "transparent", color: "white", marginLeft: "5px" }}
                                                                onClick={() => handleSort("achievedgrade")} >
                                                                {sortConfig.key === "achievedgrade"
                                                                    ? sortConfig.direction === "asc" ? "▲" : "▼"
                                                                    : "↕"} </button> </th> </tr> </thead> <tbody>
                                                    {filteredAndSortedDistrictData.length === 0 ? (
                                                        <tr>
                                                            <td className="text-center" colSpan="5">
                                                                <b style={{ color: "red" }}>
                                                                    {districtAlert ? "Details Not Found" : "No data to display"}
                                                                </b>
                                                            </td>
                                                        </tr>
                                                    ) : (
                                                        filteredAndSortedDistrictData.map((detail, i) => (
                                                            <tr
                                                                key={i}
                                                                style={{
                                                                    backgroundColor: detail.isSelected ? "#fff3cd" : "transparent",
                                                                    fontWeight: detail.isSelected ? "bold" : "normal"
                                                                }}
                                                            >
                                                                <td className="text-center">{i + 1}</td> <td>{detail?.district_name}</td>
                                                                <td style={{ textAlign: "right" }}>{detail?.noofindicators}</td>
                                                                <td className="text-center"> <div style={{ display: "flex", justifyContent: "center" }}>
                                                                        {renderStatusRing(detail.averagescore, 100, 30, 4)} </div> </td>
                                                                <td className="text-center">{detail.grade}</td>
                                                            </tr> )) )} </tbody> </table> </div>
                                    </div> </Col> </Row> </div>

                        <div className="comparison-section-header" style={{
                            background: "linear-gradient(90deg, #4e835c 0%, #6ba16f 100%)",
                            // background: "linear-gradient(90deg, #f093fb 0%, #f5576c 100%)",
                            padding: "7px 20px", borderRadius: "12px 12px 0 0", marginTop: "40px",
                            boxShadow: "0 4px 15px rgba(0,0,0,0.1)" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                                {/* <div style={{
                                    backgroundColor: "rgba(255,255,255,0.2)",
                                    borderRadius: "50%",
                                    padding: "12px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}>
                                    <span style={{ fontSize: "24px" }}>🏘️</span>
                                </div> */}
                                <div>
                                    <h2 style={{
                                        color: "white",
                                        margin: "0",
                                        fontSize: "20px",
                                        fontWeight: "600"
                                    }}>Department Wise Mandal Scores Comparison</h2>
                                </div> </div> </div>
                        <div style={{ backgroundColor: "white", borderRadius: "0 0 12px 12px",
                            boxShadow: "0 4px 15px rgba(0,0,0,0.1)", overflow: "hidden" }}>
                            <Row className="g-0">
                                {/* Mandal Graph Section */}
                                <Col md={7} className="border-end"> <div style={{ padding: "25px", height: "650px",
                                        position: "relative", backgroundColor: "#fafbfc" }}>
                                        {/* Enhanced Triple Dropdowns */}
                                        <div style={{ position: "absolute", top: "20px", left: "20px", zIndex: 10,
                                            display: "flex", gap: "12px", backgroundColor: "white", padding: "15px",
                                            borderRadius: "10px",
                                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                            border: "1px solid #e1e5e9", flexWrap: "wrap" }}>

                                            <div style={{ minWidth: "160px",maxWidth: "300px" }}>
                                                <label className="mb-2 fw-bold" style={{
                                                    fontSize: "12px",
                                                    color: "#495057",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "6px"
                                                }}>
                                                    
                                                    Department
                                                </label>
                                                <Select
                                                    {...commonSelectProps({
                                                        name: "mandal_comp_dept_id",
                                                       
                                                        options: deptlist,
                                                        value: formik.values.mandal_comp_dept_id,
                                                        optionValueKey: "dept_id",
                                                        optionLabelKey: "dept_name",
                                                        formik,
                                                        isDisabled: false,
                                                        extraOnChange: (option) => {
mandaldeptcompareclose();
                                                        } })}
                                                     styles={{ control: (base) => ({ ...base,
                                                        minHeight: "38px", fontSize: "13px", borderRadius: "8px",
                                                        border: "2px solid #e9ecef", boxShadow: "none",
                                                        "&:hover": { border: "2px solid #4e835c" } }),
                                                    option: (base, state) => ({ ...base,
                                                        backgroundColor: state.isSelected ? "#4e835c" : state.isFocused ? "#f8f9fa" : "white",
                                                        color: state.isSelected ? "white" : "#495057"
                                                    }) }} /> </div>
                                            <div style={{ minWidth: "160px",maxWidth: "200px" }}>
                                                <label className="mb-2 fw-bold" style={{
                                                    fontSize: "12px", color: "#495057", display: "flex",
                                                    alignItems: "center", gap: "6px" }}>
                                                    District </label>
                                                <Select
                                                    {...commonSelectProps({
                                                        name: "district_id",
                                                        options: distlist,
                                                        value: formik.values.district_id,
                                                        optionValueKey: "id",
                                                        optionLabelKey: "value",
                                                        formik,
                                                        isDisabled: distEnb,
                                                        extraOnChange: (option) => {
                                                            MandalDropdown(option ? option.id : "");
                                                            formik.setFieldValue("mandal_id", "");
                                                            setAllMandalScores([]);
                                                            setSelectedMandalScore(null);
                                                        } })}
                                                     styles={{ control: (base) => ({ ...base,
                                                        minHeight: "38px", fontSize: "13px", borderRadius: "8px",
                                                        border: "2px solid #e9ecef", boxShadow: "none",
                                                        "&:hover": { border: "2px solid #4e835c" } }),
                                                    option: (base, state) => ({ ...base,
                                                        backgroundColor: state.isSelected ? "#4e835c" : state.isFocused ? "#f8f9fa" : "white",
                                                        color: state.isSelected ? "white" : "#495057"
                                                    }) }} /> </div>
                                            <div style={{ minWidth: "160px",maxWidth: "200px" }}>
                                                <label className="mb-2 fw-bold" style={{ fontSize: "12px", color: "#495057",
                                                    display: "flex", alignItems: "center", gap: "6px" }}>
                                                    
                                                    Mandal
                                                </label>
                                                <Select
                                                    {...commonSelectProps({
                                                        name: "mandal_id",
                                                        options: mandallist,
                                                        value: formik.values.mandal_id,
                                                        optionValueKey: "id",
                                                        optionLabelKey: "value",
                                                        formik,
                                                        isDisabled: Mandalenb,
                                                        extraOnChange: (option) => {
                                                            loadComparisonData(formik.values.mandal_comp_dept_id, formik.values.district_id, option ? option.id : "");
                                                        } })}
                                                     styles={{ control: (base) => ({ ...base,
                                                        minHeight: "38px", fontSize: "13px", borderRadius: "8px",
                                                        border: "2px solid #e9ecef", boxShadow: "none",
                                                        "&:hover": { border: "2px solid #4e835c" } }),
                                                    option: (base, state) => ({ ...base,
                                                        backgroundColor: state.isSelected ? "#4e835c" : state.isFocused ? "#f8f9fa" : "white",
                                                        color: state.isSelected ? "white" : "#495057"
                                                    }) }} /> </div> </div>

                                        {/* Graph */}
     <div style={{ marginTop: "100px", height: "calc(100% - 100px)",
                                            overflow: "auto", backgroundColor: "white", borderRadius: "10px",
                                            padding: "15px", boxShadow: "inset 0 2px 4px rgba(0,0,0,0.06)" }}>

{/* 
  {allMandalScores.length > 0 ? (
    <div style={{ minWidth: `${filteredAndSortedData.length * 30}px`, height: "100%" }}>
      <ResponsiveContainer width="100%" height="100%" id="my-chart3">
        <BarChart
          data={filteredAndSortedData}
          margin={{ top: 20, right: 30, left: 20, bottom: 80 }}
        >
        

          <XAxis
            dataKey="mandal_name"
            angle={315}
            textAnchor="end"
            interval={0}
            height={80}
            tick={{ fontSize: 10 }}
          />

          <YAxis
            domain={[0, 100]}
            tickFormatter={(v) => `${v}%`}
            tick={{ fontSize: 10 }}
          />

          <RechartsTooltip formatter={(v) => [`${v}%`, "Score"]} />

          {selectedMandalScore && (
            <ReferenceLine
              y={selectedMandalScore.averagescore}
              stroke={selectedMandalScore.color_code || "#000"}
              strokeWidth={2}
              strokeDasharray="5 5"
               label={{
                                                                    value: `${selectedMandalScore.mandal_name}: ${selectedMandalScore.averagescore}%`,
                                                                    position: "topRight",
                                                                    fontSize: 10,
                                                                    fontWeight: 100,
                                                                    fill: selectedMandalScore.color_code || "#000",
                                                                }}
            />
          )}

          <Bar dataKey="averagescore" barSize={BAR_WIDTH}>
            {filteredAndSortedData.map((item, index) => (
              <Cell
                key={index}
                fill={item.color_code}
                opacity={item.isSelected ? 1 : 0.6}
                stroke={item.isSelected ? "#000" : "none"}
                strokeWidth={item.isSelected ? 1 : 0}
              />
            ))}
            <LabelList
              dataKey="averagescore"
              position="top"
              fill="#000"
              formatter={(value) => `${value}%`}
              fontSize={10}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  ) : (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        color: "#666"
      }}
    >
      {Mandalalert
        ? "No data available"
        : "Select district and mandal to view comparison"}
    </div>
  )} */}
   {allMandalScores.length > 0 ? (
    <div style={{ overflowX: "auto", width: "100%" }}>
    <div style={{ minWidth: `${filteredAndSortedData.length * 30}px`, height: "400px" }}>
      <ResponsiveContainer width="100%" height="100%" id="my-chart3">
        <BarChart
          data={filteredAndSortedData}
          margin={{ top: 40, right: 30, left: 20, bottom: 80 }}
        >
          {/* <CartesianGrid strokeDasharray="3 3" /> */}

          <XAxis
            dataKey="mandal_name"
            angle={315}
            textAnchor="end"
            interval={0}
            height={80}
            tick={{ fontSize: 10 }}
          />

          <YAxis
            domain={[0, 100]}
            tickFormatter={(v) => `${v}%`}
            tick={{ fontSize: 10 }}
          />

          <RechartsTooltip formatter={(v) => [`${v}%`, "Score"]} />

          {selectedMandalScore && (
            <ReferenceLine
              y={selectedMandalScore.averagescore}
              stroke={selectedMandalScore.color_code || "#000"}
              strokeWidth={2}
              strokeDasharray="5 5"
               label={{
                                                                    value: `${selectedMandalScore.mandal_name}: ${selectedMandalScore.averagescore}%`,
                                                                    position: "topRight",
                                                                    fontSize: 10,
                                                                    fontWeight: 100,
                                                                    // fill: selectedMandalScore.color_code || "#000",
                                                                    fill: "#96ebcaff",

                                                                }}
            />
          )}

          <Bar dataKey="averagescore" barSize={30} minPointSize={5}>
            {filteredAndSortedData.map((item, index) => (
              <Cell
                key={index}
                // fill={item.color_code}
                 fill={"#96ebcaff"}
                opacity={item.isSelected ? 1 : 0.6}
                stroke={item.isSelected ? "#000" : "none"}
                strokeWidth={item.isSelected ? 1 : 0}
              />
            ))}
            <LabelList
              dataKey="averagescore"
              position="top"
              fill="#000"
              formatter={(value) => `${value}%`}
              fontSize={10}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
    </div>
  ) : (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        color: "#666"
      }}
    >
      {Mandalalert
        ? "No data available"
        : "Select district and mandal to view comparison"}
    </div> )} </div> </div> </Col>

                                {/* Table Section */}
                                 <Col md={5}> <div style={{ padding: "25px", height: "550px", backgroundColor: "white" }}>
                                        {/* Enhanced Search and Export Controls */}
                                        <div style={{ backgroundColor: "#f8f9fa", padding: "15px",
                                            borderRadius: "10px", marginBottom: "20px",
                                            border: "1px solid #e9ecef" }}>
                                            <Row className="align-items-center"> <Col md={7}>
                                                    <div className="input-group"> <div className="input-group-prepend"> </div>
                                                        <input type="text" className="form-control"
                                                            placeholder="🔍 Search mandals..."
                                                            value={searchText}
                                                            onChange={(e) => setSearchText(e.target.value)}
                                                            style={{
                                                                fontSize: "13px",
                                                                border: "2px solid #e9ecef",
                                                                
                                                            }}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={5} className="text-end">
                                                    <Button
                                                        className="btn btn-danger btn-sm me-2"
                                                        onClick={() => generatedashPdf("mandal-comparison-table", "Mandal Comparison", 6,"my-chart3", "Mandal Wise Scores Comparison")}
                                                        style={{ fontSize: "12px", borderRadius: "6px", padding: "6px 12px" }} >
                                                        <MdOutlinePictureAsPdf /> PDF </Button>
                                                    <Button variant="success" size="sm"
                                                        onClick={() => exportTodashExcel("mandal-comparison-table", "Mandal Comparison")}
                                                        style={{ fontSize: "12px", borderRadius: "6px", padding: "6px 12px" }} >
                                                        <AiFillFileExcel /> Excel </Button> </Col> </Row> </div>

                                        {/* Table */}
                                        <div style={{ height: "calc(100% - 100px)", overflowY: "auto",
                                            border: "2px solid #e9ecef", borderRadius: "10px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
                                            <table className="table table-bordered table-sm mb-0"
                                                id="mandal-comparison-table" style={{ fontSize: "11px" }} >
                                                <thead className="sticky-top" style={{ backgroundColor: "#4e835c", color: "white" }}>
                                                    <tr>
                                                        <th style={{ width: "8%", backgroundColor: "#4e835c", color: "white" }}>S.No</th>
                                                        <th style={{ width: "20%", backgroundColor: "#4e835c", color: "white" }}>
                                                            District 
                                                            <button
                                                                style={{ border: "none", background: "transparent", color: "white", marginLeft: "5px" }}
                                                                onClick={() => handleSort("district_name")}
                                                            >
                                                                {sortConfig.key === "district_name"
                                                                    ? sortConfig.direction === "asc" ? "▲" : "▼"
                                                                    : "↕"}
                                                            </button>
                                                        </th>
                                                        <th style={{ width: "20%", backgroundColor: "#4e835c", color: "white" }}>
                                                            Mandal <button style={{ border: "none", background: "transparent", color: "white", marginLeft: "5px" }}
                                                                onClick={() => handleSort("mandal_name")} >
                                                                {sortConfig.key === "mandal_name"
                                                                    ? sortConfig.direction === "asc" ? "▲" : "▼"
                                                                    : "↕"} </button> </th>
                                                        <th style={{ width: "20%", backgroundColor: "#4e835c", color: "white" }}>
                                                            Indicators
                                                            <button
                                                                style={{ border: "none", background: "transparent", color: "white", marginLeft: "5px" }}
                                                                onClick={() => handleSort("noofindicators")}
                                                            >
                                                                {sortConfig.key === "noofindicators"
                                                                    ? sortConfig.direction === "asc" ? "▲" : "▼"
                                                                    : "↕"}
                                                            </button>
                                                        </th>
                                                        <th style={{ width: "17%", backgroundColor: "#4e835c", color: "white" }}>
                                                            Score
                                                            <button
                                                                style={{ border: "none", background: "transparent", color: "white", marginLeft: "5px" }}
                                                                onClick={() => handleSort("achievedscore")}
                                                            >
                                                                {sortConfig.key === "achievedscore"
                                                                    ? sortConfig.direction === "asc" ? "▲" : "▼"
                                                                    : "↕"}
                                                            </button>
                                                        </th>
                                                        <th style={{ width: "20%", backgroundColor: "#4e835c", color: "white" }}>
                                                            Grade
                                                            <button
                                                                style={{ border: "none", background: "transparent", color: "white", marginLeft: "5px" }}
                                                                onClick={() => handleSort("achievedgrade")}
                                                            >
                                                                {sortConfig.key === "achievedgrade"
                                                                    ? sortConfig.direction === "asc" ? "▲" : "▼"
                                                                    : "↕"}
                                                            </button>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {filteredAndSortedData.length === 0 ? (
                                                        <tr>
                                                            <td className="text-center" colSpan="5">
                                                                <b style={{ color: "red" }}>
                                                                    {Mandalalert ? "Details Not Found" : "No data to display"}
                                                                </b>
                                                            </td>
                                                        </tr>
                                                    ) : (
                                                        filteredAndSortedData.map((detail, i) => (
                                                            <tr
                                                                key={i}
                                                                style={{
                                                                    backgroundColor: detail.isSelected ? "#fff3cd" : "transparent",
                                                                    fontWeight: detail.isSelected ? "bold" : "normal"
                                                                }}
                                                            >
                                                                <td className="text-center">{i + 1}</td>
                                                                <td>{detail?.district_name}</td>
                                                                <td>{detail?.mandal_name}</td>
                                                                <td style={{ textAlign: "right" }}>{detail?.noofindicators}</td>
                                                                <td className="text-center">
                                                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                                                        {renderStatusRing(detail.averagescore, 100, 30, 4)}
                                                                    </div>
                                                                </td>
                                                                <td className="text-center">{detail.grade}</td>
                                                            </tr>
                                                        ))
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            {/* {Mandalalert && (
                                <Row className="mt-3">
                                    <Col xs={12}>
                                        <Alert severity="warning">
                                            Mandal Level Indicators are Not Available
                                        </Alert>
                                    </Col>
                                </Row>
                            )} */}
                        </div>

                    </Form>
                </FormikProvider>

              
            </Container>

            <AlertModal
                show={showAlert}
                titleText={alertData.titleText}
                alertText={alertData.alertText}
                onClose={closeAlert}
            />
        </>
    );
}